<template>
	<div>
		<div class="l-medal-tab">
			<div class="l-medal-content">
				<div @click="onTabChange(2)" class="l-medal-culture" :class="{ 'l-culture-pitch ': tabNumber == 2 }">
					武功
					<div v-show="isCultureRed" class="red-position"></div>
				</div>
				<div @click="onTabChange(1)" class="l-medal-power" :class="{ 'l-power-pitch': tabNumber == 1 }">
					文功
					<div class="red-position" v-show="isPowerRed"></div>
				</div>
			</div>
		</div>
		<img class="l-achievement-medal" src="./images/back-top-medal.png" />
		<img class="l-achievement-bottom" src="./images/back-bottom-medal.png" width="100%" alt="" />
		<img class="l-achievement-left" src="./images/back-left-medal.png" alt="" />
		<img class="l-achievement-right" src="./images/back-right-medal.png" alt="" />
		<!-- <div @click="onGetMedalShow" class="l-achievement-float">已获得</div> -->
		<!-- <div v-show="isMedalPopup" class="l-medal-popup dark"></div> -->
		<transition name="shrink">
			<div v-show="isMedalPopup" class="l-medal-popup">
				<div class="l-medal-main">
					<div class="l-medal-down" @click="isMedalPopup = false"></div>
					<div class="l-medal-popup-tab">
						<div @click="onPopupTabChange(2)" class="l-medal-culture"
							:class="{ 'l-culture-pitch ': popupTabNumber == 2 }">
							武功
						</div>
						<div @click="onPopupTabChange(1)" class="l-medal-power" :class="{ 'l-power-pitch': popupTabNumber == 1 }">
							文功
						</div>
					</div>
					<div class="l-medal-cabinet">
						<div class="l-medal-cabinet-list" v-for="(item, index) in popupList" :key="index">
							<div class="l-medal-cabinet-item" v-for="(items, _index) in item" :key="_index">
								<img :src="items.unlockImgUrl" alt="" />
								<div class="">
									{{ items.name }}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</transition>
	</div>
</template>
<script>
import AccountModel from '@/models/account'
const accountModel = new AccountModel()
export default {
	name: 'l-achievement-medal',
	props: {
		tabNumber: {
			type: Number,
			default: 2,
		},
		disabled: {
			type: Boolean,
			default: true,
		},
		isFulfillList: {
			type: Array,
		},
	},
	computed: {
		isCultureRed() {
			if (this.isFulfillList.length < 3) {
				return 0
			}
			let list = []
			list = this.isFulfillList.filter((item) => {
				return item.type == 2
			})[0]
			if (list.children) {
				return list.children.filter((res) => {
					return res.type == 2
				})[0].value
			} else {
				return 0
			}
		},
		isPowerRed() {
			if (this.isFulfillList.length < 3) {
				return 0
			}
			return this.isFulfillList
				.filter((item) => {
					return item.type == 2
				})[0]
				.children.filter((item) => {
					return item.type == 1
				})[0].value
		},
	},
	data() {
		return {
			isMedalPopup: false, //弹窗
			popupList: [], //荣誉墙列表
			popupTabNumber: 2,
		}
	},

	created() { },
	updated() { },
	methods: {
		onTabChange(number) {
			if (!this.disabled) {
				return
			}
			this.$emit('onTabChange', number)
		},

		onGetPopupList() {
			this.popupList = []
			accountModel.awaredList({ type: 2 }).then(async (res) => {
				let list = []
				res.data.forEach((element) => {
					if (element.config.medalType === this.popupTabNumber) {
						list.push({
							...element,
							...element.config,
						})
					}
				})
				this.popupList = list
				if (this.popupList.length > 0) {
					this.popupList = this.setListToMatrix(this.popupList, 3)
				}
			})
		},
		onPopupTabChange(number) {
			if (!this.disabled) {
				return
			}
			this.popupTabNumber = number
			this.onGetPopupList()
		},
		//已获得勋章展示
		onGetMedalShow() {
			if (!this.disabled) {
				return
			}
			this.isMedalPopup = !this.isMedalPopup

			this.onGetPopupList()
		},
		setListToMatrix(list, number) {
			let matrix = [],
				i,
				k
			for (i = 0, k = -1;i < list.length;i++) {
				if (i % number == 0) {
					k++
					matrix[k] = []
				}
				matrix[k].push(list[i])
			}
			return matrix
		},
	},
}
</script>

<style scoped lang="stylus">
@import './index.styl';
</style>
